// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
// import { connect } from "react-redux";
import { Button, Input } from "../../../../revvComponents";

// Action Imports
// import { DocumentTemplateActions } from "../../../actions";

// Internal Imports
import { TEMPLATE } from "../../../../constants";

// Destructuring
const { TEMPLATE_STATUSES_FOR_FILTER: TEMP_STATUSES } = TEMPLATE;
// const {
//   updateStatusFilters,
//   getAssetFolderContentAction,
//   updateAssetSearchContentAction,
// } = AssetActions;

class TemplatesStatusFilterPopup extends Component {
  state = { filtersLocalState: [] };

  componentDidMount() {
    this.setState({ filtersLocalState: this.props.templatesStatusFilters });
  }

  _closePopup = () => {
    this.props.togglePopup(false);
  };

  _toggleCheckbox = status => {
    const { filtersLocalState } = this.state;
    const filtersCopy = [...filtersLocalState];
    if (filtersLocalState.includes(status)) {
      const index = filtersCopy.indexOf(status);
      if (index > -1) {
        filtersCopy.splice(index, 1);
      }
    } else {
      filtersCopy.push(status);
    }
    this.setState({ filtersLocalState: filtersCopy });
  };

  _applyFiltersAndFetchAssets = () => {
    this.props.updateStatusFilters(this.state.filtersLocalState);
    this._closePopup();
    this.props.applyFilters(this.state.filtersLocalState);
  };

  render() {
    const { filtersLocalState } = this.state;
    return (
      <Modal open onClose={this._closePopup} closeOnOverlayClick={false} center>
        <div
          className="assetcustomizecolumnpopup-container"
          data-test="assetcustomizecolumnpopup-container">
          {/* ---------- Modal Heading Section ---------- */}
          <div
            className="assetfilter-modal-heading"
            data-test="assetfilter-modal-heading">
            Filter based on Status
          </div>
          <div className="assetfilter-modal-subheading">
            You can use this filter to organsie your templates based on status
          </div>
        </div>

        <div className="assetcustomizecolumnpopup-columns-wrapper">
          {Object.keys(TEMP_STATUSES).map(status => (
            <span>
              <span className="asset-filter-item">
                <Input
                  id={status}
                  data-test={`status-filter-${status}`}
                  type="checkbox"
                  value=""
                  checked={filtersLocalState.includes(status)}
                  onChange={() => this._toggleCheckbox(status)}
                />
                <label className="asset-filter-item-label" htmlFor={status}>
                  {TEMP_STATUSES[status].label}
                </label>
              </span>
            </span>
          ))}
        </div>

        {/* ---------- Action Buttons Section ---------- */}
        <div className="createquotepopup-footer popup-footer asset-filter-popupfooter">
          <div className="footer-actions">
            <Button
              className="btn btn-transparent createquotepopup-footer-cancelbtn"
              data-test="assetmovetofolder-movetofolder-cancel-button"
              onClick={this._closePopup}>
              Cancel
            </Button>
            <Button
              type="four"
              data-test="assetmovetofolder-movetofolder-button"
              onClick={() => this._applyFiltersAndFetchAssets()}>
              Apply Filters
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default TemplatesStatusFilterPopup;
